"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_SMS_CONTENT_ERROR_MSG = exports.SEND_CUSTOM_SMS = void 0;
exports.SEND_CUSTOM_SMS = 'Custom SMS';
exports.EMPTY_SMS_CONTENT_ERROR_MSG = 'Please pick an available SMS choice or provide a custom one.';
